webpackJsonp([55702396619907],{

/***/ 1561:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Gatsby + Netlify CMS Starter"}},"allMarkdownRemark":{"group":[{"fieldValue":"High River On Line News  - Written by Cory Gialleonardo","totalCount":1},{"fieldValue":"Mom & Daughter recover together - 'I wouldn't be here if my mom wasn't here","totalCount":1},{"fieldValue":"News","totalCount":2},{"fieldValue":"Overcoming Addiction","totalCount":1},{"fieldValue":"Recovery","totalCount":1},{"fieldValue":"Rehabilitation","totalCount":1},{"fieldValue":"Restoration","totalCount":1},{"fieldValue":"Video Link","totalCount":1},{"fieldValue":"Year Round Greenhouse Grown","totalCount":1},{"fieldValue":"from the residents","totalCount":1},{"fieldValue":"media","totalCount":11},{"fieldValue":"news","totalCount":7},{"fieldValue":"recovery & healing","totalCount":3}]}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-30924f34da795b1e8bc5.js